import {Component, OnInit, Output, EventEmitter, Input} from '@angular/core';

@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.less']
})
export class MenuComponent implements OnInit {
    @Output() gotoLink: EventEmitter<any> = new EventEmitter();

    @Input() isLinkColorBlack: boolean = false;
    @Input() currentActiveSection: string = "";

    constructor() {
    }

    ngOnInit() {}

    goTo(section: string) {
        if (section == this.currentActiveSection) return;
        this.gotoLink.emit(section);
    }
}



// WEBPACK FOOTER //
// /Users/davidlagace/Sites/david-lagace-website/src/app/menu/menu.component.ts